import * as am4core from '@amcharts/amcharts4/core';

// These colors are shown in the column chart demo here, with the theme set to "no theme":
// https://www.amcharts.com/demos/column-chart-with-axis-break/
export const defaultHexColors = [
    '#67b7dc',
    '#6794dc',
    '#6771dc',
    '#8067dc',
    '#a367dc',
    '#c767dc',
    '#dc67ce',
    '#dc67ab',
    '#dc6788',
    '#dc6967',
    '#dc8c67',
    '#dcaf67',
];
/**
 * To use this function, set the properties on a series like this:
 *
 *     networkSeries.colors.list = defaultChartColors;
 *     networkSeries.colors.reuse = true; // <- allows the colors to be cycled through again if there are more nodes than colors
 */
export const defaultChartColors = defaultHexColors.map(
    (hexColor: string): am4core.Color => am4core.color(hexColor),
);
